export default __webpack_public_path__ + "static/0209-27032d0ba335ed15e2da5356594de969.png";